import { render, staticRenderFns } from "./LocationDetail.vue?vue&type=template&id=0d6f427d&scoped=true&"
import script from "./LocationDetail.vue?vue&type=script&lang=js&"
export * from "./LocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./LocationDetail.vue?vue&type=style&index=0&id=0d6f427d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f427d",
  null
  
)

export default component.exports